/// <reference types="google.maps" />
import { fromAddress, fromLatLng, setKey, setLocationType } from "react-geocode";

export class Geocoder {
	constructor() {
		setKey("AIzaSyDcKVNzjWpSbwSvi8lig6-b5m9iXn7I1zI");
		setLocationType("ROOFTOP");
	}

	public fromAddress(this: void, address: string) {
		return fromAddress(address);
	}

	public async fromLatLng(this: void, lat: number, lng: number, filterTypes?: string[]) {
		const { results: geocoderResults } = (await fromLatLng(lat, lng)) as GeocoderResult;
		const filteredResults = filterTypes?.length
			? geocoderResults.filter(({ types }) => types.some((type) => filterTypes.includes(type)))
			: geocoderResults;
		const results = filteredResults.length ? filteredResults : geocoderResults;
		const sorted = [...results];
		sorted.sort(premisesFirst);
		return sorted;
	}
}

function premiseRank({ types }: google.maps.GeocoderResult) {
	return types.includes("premise") ? 0 : 1;
}

function premisesFirst(a: google.maps.GeocoderResult, b: google.maps.GeocoderResult) {
	return premiseRank(a) - premiseRank(b);
}

interface GeocoderResult {
	status: string;
	results: google.maps.GeocoderResult[];
}
